// extracted by mini-css-extract-plugin
export default {"bannerLink":"c9xQrJX5mL98ShDHXnAg","bannerImage":"Z94iiYxICzxJForrEGjT"};